// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.c-video-wrapper[data-v-6c1586fa] {\n  position: relative;\n  max-width: 100%;\n  min-height: 200px;\n  background-size: contain;\n  aspect-ratio: 4 / 3;\n  height: 100%;\n  margin: auto;\n}\nvideo[data-v-6c1586fa] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  -o-object-fit: contain;\n     object-fit: contain;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
